/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/sections/opk-tos.js":
/*!*****************************************!*\
  !*** ./src/scripts/sections/opk-tos.js ***!
  \*****************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

eval("{__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _styles_sections_opk_tos_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../styles/sections/opk-tos.scss */ \"./src/styles/sections/opk-tos.scss\");\n\ndocument.addEventListener('DOMContentLoaded', () => {\n  const root = document.querySelector('[data-js-opk-tos]');\n  if (!root) return;\n  const content = root.querySelector('[data-js-opk-tos-content]');\n  const nav = root.querySelector('[data-js-opk-tos-nav]');\n  if (!content || !nav) return;\n  const titles = Array.from(content.querySelectorAll('h2'));\n  if (!titles.length) return;\n  const HEADER_OFFSET = 135;\n  nav.innerHTML = '';\n  const linkById = new Map();\n  titles.forEach((title, index) => {\n    const text = title.textContent.trim();\n    const id = `opk-tos-link-${index}`;\n    title.id = id;\n    const link = document.createElement('a');\n    link.textContent = text;\n    link.href = `#${id}`;\n    link.classList.add('opk-tos__nav-link');\n    nav.appendChild(link);\n    linkById.set(id, link);\n  });\n  const setActive = id => {\n    nav.querySelectorAll('.opk-tos__nav-link.is-active').forEach(a => a.classList.remove('is-active'));\n    const activeLink = linkById.get(id);\n    if (activeLink) activeLink.classList.add('is-active');\n  };\n  setActive(titles[0].id);\n  const io = new IntersectionObserver(entries => {\n    const visible = entries.filter(e => e.isIntersecting);\n    if (!visible.length) return;\n    visible.sort((a, b) => {\n      const aDist = Math.abs(a.boundingClientRect.top - HEADER_OFFSET);\n      const bDist = Math.abs(b.boundingClientRect.top - HEADER_OFFSET);\n      return aDist - bDist;\n    });\n    setActive(visible[0].target.id);\n  }, {\n    root: null,\n    rootMargin: `-${HEADER_OFFSET}px 0px -60% 0px`,\n    threshold: [0, 0.1, 0.25, 0.5, 0.75, 1]\n  });\n  titles.forEach(h2 => io.observe(h2));\n});\n\n//# sourceURL=webpack://trendmodenl/./src/scripts/sections/opk-tos.js?\n}");

/***/ }),

/***/ "./src/styles/sections/opk-tos.scss":
/*!******************************************!*\
  !*** ./src/styles/sections/opk-tos.scss ***!
  \******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

eval("{__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://trendmodenl/./src/styles/sections/opk-tos.scss?\n}");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Check if module exists (development only)
/******/ 		if (__webpack_modules__[moduleId] === undefined) {
/******/ 			var e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/scripts/sections/opk-tos.js");
/******/ 	
/******/ })()
;